import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT, IMAGES } from "@/lib/data";

const links = [
  { label: "Why Us", href: "#features" },
  { label: "Our Cars", href: "#fleet" },
  { label: "Payments", href: "#payments" },
  { label: "Book Now", href: "#book" },
  { label: "FAQ", href: "#faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-navy/10 shadow-md" : "bg-white/70 backdrop-blur-md border-b border-navy/5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center group">
          <img src={IMAGES.logo} alt="ORL On Demand Rides logo" className="h-9 md:h-11 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className="font-medium text-sm text-navy/80 hover:text-gold-dark transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            data-testid="header-call-btn"
            className="inline-flex items-center gap-2 rounded-full bg-navy px-4 md:px-5 py-2.5 text-white text-sm font-semibold hover:bg-navy-light hover:-translate-y-0.5 transition-all duration-300 shadow-md"
          >
            <Phone className="w-4 h-4" />
            <span className="hidden sm:inline">{CONTACT.phoneDisplay}</span>
            <span className="sm:hidden">Call</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-1 text-navy"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-navy/10 px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className="font-medium text-navy/80 py-1"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
